module.exports = __webpack_public_path__ + "img/_figure-ico.cc33fde3.svg";